import {
  createPlugin,
  createComponentExtension,
  createRoutableExtension,
  createRouteRef,
} from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({ id: 'railway-cost' });

export const railwayCostPlugin = createPlugin({
  id: 'railway-cost',
  routes: { root: rootRouteRef },
});

export const RailwayCostPage = railwayCostPlugin.provide(
  createRoutableExtension({
    name: 'RailwayCostPage',
    component: () =>
      import('./components/RailwayCostPage').then(m => m.RailwayCostPage),
    mountPoint: rootRouteRef,
  }),
);

export const EntityRailwayCostCard = railwayCostPlugin.provide(
  createComponentExtension({
    name: 'EntityRailwayCostCard',
    component: {
      lazy: () =>
        import('./components/EntityRailwayCostCard').then(
          m => m.EntityRailwayCostCard,
        ),
    },
  }),
);

export const RailwayCostHomeCard = railwayCostPlugin.provide(
  createComponentExtension({
    name: 'RailwayCostHomeCard',
    component: {
      lazy: () =>
        import('./components/RailwayCostHomeCard').then(
          m => m.RailwayCostHomeCard,
        ),
    },
  }),
);
